import { call, put, takeLatest } from "redux-saga/effects";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , callbackSaga
  , subKeySaga
  , fillDictionary
  , handleCallback
  , multipleObjectReturn
} from "shared-utility/store/utils/helpers";

import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";

const initialState = {
  hedge: null,
  deal: null,
  companiesByTypeId: [],
  companyCreditRatings: {},
  dealLoans: []
};

// ACTIONS

export const HEDGE_DETAIL_DELETE_HEDGE = generateDefaultActions("HEDGE_DETAIL_DELETE_HEDGE");
export const deleteHedge = payload => makePayload(HEDGE_DETAIL_DELETE_HEDGE.value, payload);
function* deleteHedgeSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/hedge/deleteHedge/${payload.hedgeId}`;
  yield requestSaga(HEDGE_DETAIL_DELETE_HEDGE, url, "DELETE");
  yield callback();
}
export const HEDGE_DETAIL_GET_HEDGE = generateDefaultActions("HEDGE_DETAIL_GET_HEDGE");
export const hedgeDetailGetHedge = payload => makePayload(HEDGE_DETAIL_GET_HEDGE.value, payload);
function* hedgeDetailGetHedgeSaga(payload) {
  const url = `/hedges/${payload.hedgeId}`;
  yield requestSaga(HEDGE_DETAIL_GET_HEDGE, url, "GET");
}

export const HEDGE_DETAIL_GET_DEAL_METRICS = generateDefaultActions("HEDGE_DETAIL_GET_DEAL_METRICS");
export const hedgeDetailGetDealMetrics = payload => makePayload(HEDGE_DETAIL_GET_DEAL_METRICS.value, payload);
function* hedgeDetailGetDealMetricsSaga(payload) {
  const { hedgeId, dealMetrics } = payload;
  const url = `/hedges/${hedgeId}/dealMetrics`;

  yield requestSaga(HEDGE_DETAIL_GET_DEAL_METRICS, url, "POST", { dealMetrics });
}

export const HEDGE_DETAIL_UPDATE_HEDGE = generateDefaultActions("HEDGE_DETAIL_UPDATE_HEDGE");
export const updateHedge = payload => makePayload(HEDGE_DETAIL_UPDATE_HEDGE.value, payload);
function* updateHedgeSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;

  const url = "/hedge";
  const requestSaga = subKeySaga(payload.hedgeStatus);
  yield requestSaga(HEDGE_DETAIL_UPDATE_HEDGE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const HEDGE_DETAIL_GET_NEW_HEDGE = generateDefaultActions("HEDGE_DETAIL_GET_NEW_HEDGE");
export const hedgeDetailGetNewHedge = payload => makePayload(HEDGE_DETAIL_GET_NEW_HEDGE.value, payload);
function* hedgeDetailGetNewHedgeSaga(payload) {
  const url = `/hedges/new/${payload.dealId}`;// Confirm this route exists
  yield requestSaga(HEDGE_DETAIL_GET_NEW_HEDGE, url, "GET");
}

export const HEDGE_DETAIL_CREATE_HEDGE = generateDefaultActions("HEDGE_DETAIL_CREATE_HEDGE");
export const hedgeDetailCreateHedge = payload => makePayload(HEDGE_DETAIL_CREATE_HEDGE.value, payload);
function* hedgeDetailCreateHedgeSaga(payload) {
  const { hedge, dealId, callback } = payload;
  const url = `/deals/${dealId}/createHedge`;// Confirm this route exists
  yield requestSaga(HEDGE_DETAIL_CREATE_HEDGE, url, "POST", hedge);
  if (callback) {
    callback();
  }
}

export const HEDGE_DETAIL_GET_DEAL_PROPERTIES = generateDefaultActions("HEDGE_DETAIL_GET_DEAL_PROPERTIES");
export const hedgeDetailGetDealProperties = payload => makePayload(HEDGE_DETAIL_GET_DEAL_PROPERTIES.value, payload);
function* hedgeDetailGetDealPropertiesSaga(payload) {
  const url = `/properties/hedge/${payload.hedgeId}`;// Confirm this route exists
  yield requestSaga(HEDGE_DETAIL_GET_DEAL_PROPERTIES, url, "GET");
}

// START NOTES
export const HEDGE_DETAIL_GET_NOTES = generateDefaultActions("HEDGE_DETAIL_GET_NOTES");
export const hedgeGetNotes = payload => makePayload(HEDGE_DETAIL_GET_NOTES.value, payload);
function* hedgeGetNotesSaga(payload) {
  const url = `/hedge/notes/${payload.hedgeId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(HEDGE_DETAIL_GET_NOTES, url, "GET");
}

export const HEDGE_DETAIL_PUT_NOTE = generateDefaultActions("HEDGE_DETAIL_PUT_NOTE");
export const hedgePutNote = payload => makePayload(HEDGE_DETAIL_PUT_NOTE.value, payload);
function* hedgePutNoteSaga(payload) {
  const url = `/notes/${payload.note.id}`;
  yield requestSaga(HEDGE_DETAIL_PUT_NOTE, url, "PUT", payload);
  yield put(hedgeGetNotes({ hedgeId: payload.hedgeId }));
}

export const HEDGE_DETAIL_POST_NOTE = generateDefaultActions("HEDGE_DETAIL_POST_NOTE");
export const hedgePostNote = payload => makePayload(HEDGE_DETAIL_POST_NOTE.value, payload);
function* hedgePostNoteSaga(payload) {
  const url = "/notes";
  const note = {
    model: "hedge",
    modelId: payload.hedgeId,
    note: payload.note,
    pinned: false
  };
  yield requestSaga(HEDGE_DETAIL_POST_NOTE, url, "POST", { note });
  yield put(hedgeGetNotes({ hedgeId: payload.hedgeId }));
}

export const HEDGE_DETAIL_DELETE_NOTE = generateDefaultActions("HEDGE_DETAIL_DELETE_NOTE");
export const hedgeDeleteNote = payload => makePayload(HEDGE_DETAIL_DELETE_NOTE.value, payload);
function* hedgeDeleteNoteSaga(payload) {
  const url = `/notes/${payload.noteId}`;
  yield requestSaga(HEDGE_DETAIL_DELETE_NOTE, url, "DELETE");
  yield put(hedgeGetNotes({ hedgeId: payload.hedgeId }));
}
// END NOTES

// START ATTACHMENTS

export const hedgeGetAttachments = payload => makePayload(HEDGE_DETAIL_GET_ATTACHMENTS.value, payload);
export const HEDGE_DETAIL_GET_ATTACHMENTS = generateDefaultActions("HEDGE_DETAIL_GET_ATTACHMENTS");
function* hedgeGetAttachmentsSaga(payload) {
  const url = "/getFiles/byModel";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(HEDGE_DETAIL_GET_ATTACHMENTS, url, "POST", payload);
}

export const HEDGE_DETAIL_PUT_ATTACHMENT = generateDefaultActions("HEDGE_DETAIL_PUT_ATTACHMENT");
export const hedgePutAttachment = payload => makePayload(HEDGE_DETAIL_PUT_ATTACHMENT.value, payload);
function* hedgePutAttachmentSaga(payload) {
  const url = "/files";
  payload = {
    ...payload,
    id: payload.file.id,
    isPrivate: payload.file.isPrivate,
    model: "hedge",
    modelId: payload.hedgeId,
    url: "/files",
    name: payload.file.name
  };

  yield requestSaga(HEDGE_DETAIL_PUT_ATTACHMENT, url, "PUT", payload);
  yield put(hedgeGetAttachments({ modelName: "hedge", modelId: payload.hedgeId }));
}

export const HEDGE_DETAIL_POST_ATTACHMENT = generateDefaultActions("HEDGE_DETAIL_POST_ATTACHMENT");
export const hedgePostAttachment = payload => makePayload(HEDGE_DETAIL_POST_ATTACHMENT.value, payload);
function* hedgePostAttachmentSaga(payload) {
  const callback = handleCallback(payload);
  payload = {
    ...payload,
    model: "hedge",
    modelId: payload.hedgeId,
    url: "/files"
  };

  yield call(uploadFile, payload);
  yield put(HEDGE_DETAIL_POST_ATTACHMENT.createSuccess());
  yield put(hedgeGetAttachments({ modelName: "hedge", modelId: payload.hedgeId }));
  yield callback();
}

export const HEDGE_DETAIL_DELETE_ATTACHMENT = generateDefaultActions("HEDGE_DETAIL_DELETE_ATTACHMENT");
export const hedgeDeleteAttachment = payload => makePayload(HEDGE_DETAIL_DELETE_ATTACHMENT.value, payload);
function* hedgeDeleteAttachmentSaga(payload) {
  const url = `/files/${payload.fileId}`;
  const callback = handleCallback(payload);

  yield requestSaga(HEDGE_DETAIL_DELETE_ATTACHMENT, url, "DELETE", payload);
  yield put(hedgeGetAttachments({ modelName: "hedge", modelId: payload.hedgeId }));
  yield callback();
}

// END ATTACHMENTS

// REDUCER
export function hedgeDetailReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case HEDGE_DETAIL_DELETE_HEDGE.success:
      ToastSuccess("Successfully Deleted");

      return defaultReturn(state);

    case HEDGE_DETAIL_GET_NEW_HEDGE.success:
    case HEDGE_DETAIL_GET_HEDGE.success:
      return multipleObjectReturn(state, ["hedge", "guestPermission"], [payload.data, payload.guestPermission]);

    case HEDGE_DETAIL_UPDATE_HEDGE.success:
      ToastSuccess("Hedge Successfully updated");

      return state;

    case HEDGE_DETAIL_GET_DEAL_METRICS.success:
      return defaultReturn(state, payload.data, "deal");

    case HEDGE_DETAIL_GET_DEAL_PROPERTIES.success:
      return defaultReturn(state, payload.data, "dealProperties");

      // ATTACHMENTS

    case HEDGE_DETAIL_GET_ATTACHMENTS.success:
      return defaultReturn(state, payload.data, "attachments");

    case HEDGE_DETAIL_PUT_ATTACHMENT.success:
      ToastSuccess("File Successfully Updated");

      return defaultReturn(state);

    case HEDGE_DETAIL_POST_ATTACHMENT.success:
      ToastSuccess("File Successfully Added");

      return defaultReturn(state);

    case HEDGE_DETAIL_DELETE_ATTACHMENT.success:
      ToastSuccess("File Successfully Deleted");

      return state;

      // NOTES

    case HEDGE_DETAIL_GET_NOTES.success:
      return defaultReturn(state, payload.data, "notes");

    case HEDGE_DETAIL_POST_NOTE.success:
      ToastSuccess("Note Successfully Added");

      return defaultReturn(state);

    case HEDGE_DETAIL_PUT_NOTE.success:
      ToastSuccess("Note Successfully Updated");

      return defaultReturn(state);

    case HEDGE_DETAIL_DELETE_NOTE.success:
      ToastSuccess("Note Successfully Deleted");

      return state;

    default:
      return state;
  }
}

// SAGA

export function* hedgeDetailSaga() {
  yield takeLatest(HEDGE_DETAIL_GET_HEDGE.value, hedgeDetailGetHedgeSaga);
  yield takeLatest(HEDGE_DETAIL_GET_DEAL_METRICS.value, hedgeDetailGetDealMetricsSaga);
  yield takeLatest(HEDGE_DETAIL_UPDATE_HEDGE.value, updateHedgeSaga);
  yield takeLatest(HEDGE_DETAIL_GET_NEW_HEDGE.value, hedgeDetailGetNewHedgeSaga);
  yield takeLatest(HEDGE_DETAIL_CREATE_HEDGE.value, hedgeDetailCreateHedgeSaga);
  yield takeLatest(HEDGE_DETAIL_GET_DEAL_PROPERTIES.value, hedgeDetailGetDealPropertiesSaga);

  yield takeLatest(HEDGE_DETAIL_GET_ATTACHMENTS.value, hedgeGetAttachmentsSaga);
  yield takeLatest(HEDGE_DETAIL_PUT_ATTACHMENT.value, hedgePutAttachmentSaga);
  yield takeLatest(HEDGE_DETAIL_POST_ATTACHMENT.value, hedgePostAttachmentSaga);
  yield takeLatest(HEDGE_DETAIL_DELETE_ATTACHMENT.value, hedgeDeleteAttachmentSaga);
  yield takeLatest(HEDGE_DETAIL_GET_NOTES.value, hedgeGetNotesSaga);
  yield takeLatest(HEDGE_DETAIL_PUT_NOTE.value, hedgePutNoteSaga);
  yield takeLatest(HEDGE_DETAIL_POST_NOTE.value, hedgePostNoteSaga);
  yield takeLatest(HEDGE_DETAIL_DELETE_NOTE.value, hedgeDeleteNoteSaga);
  yield takeLatest(HEDGE_DETAIL_DELETE_HEDGE.value, deleteHedgeSaga);
}
